import { useCallback, useMemo } from "react";
import {
  InternalAdminEditUserMutation,
  InternalAdminEditUserMutationVariables,
  InternalAdminUserFragment,
} from "gql/graphql";
import { UserPreferenceName } from "modules/utils/Constants";
import { useMutation } from "@apollo/client";
import INTERNAL_ADMIN_EDIT_USER_MUTATION from "../_networking/internal-admin-edit-user";

interface IProps {
  user: InternalAdminUserFragment;
  name: UserPreferenceName;
}

const useInternalAdminUserPreference = ({ user, name }: IProps) => {
  const stringValue = useMemo(
    () => user?.userPreferenceList.find((pref) => pref.name === name)?.value,
    [name, user?.userPreferenceList],
  );

  const booleanValue = useMemo(
    () =>
      user?.userPreferenceList.find((pref) => pref.name === name)?.value ===
      "true",
    [name, user?.userPreferenceList],
  );

  const [internalAdminEditUserMutationAPI] = useMutation<
    InternalAdminEditUserMutation,
    InternalAdminEditUserMutationVariables
  >(INTERNAL_ADMIN_EDIT_USER_MUTATION);

  const editUserPreference = useCallback(
    (value: string) => {
      internalAdminEditUserMutationAPI({
        variables: {
          organizationId: user.organizationId,
          id: user.id,
          input: {
            userPreferenceList: [
              {
                name,
                value,
              },
            ],
          },
        },
      });
    },
    [internalAdminEditUserMutationAPI, name, user.id, user.organizationId],
  );

  return {
    stringValue,
    booleanValue,
    editUserPreference,
  };
};

export default useInternalAdminUserPreference;
